import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';
import Progress from "../Progress";

class Image extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: '',
			image: this.props.image
		};


		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.goBack = this.goBack.bind(this);


	}

	componentWillReceiveProps(nextProps, nextContext) {
		this.setState({image: nextProps.image})
	}

	componentDidMount() {
	  window.scrollTo(0, 0);

	}

	render() {
		return(
			<div className="container main">
				<div className="info-overlay"></div>
				<div className="more-info">
					<i className="closeInfo fas fa-times"></i>
					<div className="more-info-container"></div>
				</div>
				<Progress t={this.props.t} goTo={this.props.goTo} step={2} traject={this.props.traject} />
				<form className="row beforeSizes" onSubmit={this.handleSubmit}>

					<div className="col-12 text-center title">
						<h2>{this.props.t('Wat weegt voor jou het zwaarst in de fietskeuze?')}</h2>
					</div>

					<div className="col-12 option">

						<div className="row">
							<div className="col-sm-7" style={{background: "url(/img/image_1.jpg)"}}>
							</div>
							<div className="col-sm-4 vcenter">
								<div>
									<h3>{this.props.t('Image-Best Fits')}</h3>
									<span>{this.props.t('Image-title')}</span>
								</div>
							</div>
							<div className="col-sm-1 vcenter">
								<div className="radio-container">
									<input type="radio" name="beforeSizes" checked={this.state.image === '1' ? 'checked' : ''} value='1' onChange={this.handleChange} />
								</div>
							</div>
						</div>
					</div>
					<div className="col-12 option">

						<div className="row">
							<div className="col-sm-7" style={{background: "url(/img/image_2.jpg)"}}>
							</div>
							<div className="col-sm-4 vcenter">
								<div>
									<h3>{this.props.t('Juiste merk')}</h3>
									<span>{this.props.t('Ik heb een voorkeur voor specifieke merken')}</span>
								</div>
							</div>
							<div className="col-sm-1 vcenter">
								<div className="radio-container">
									<input type="radio" name="beforeSizes" checked={this.state.image === '2' ? 'checked' : ''} value='2' onChange={this.handleChange} />
								</div>
							</div>
						</div>
					</div>
					<div className="col-12 option">

						<div className="row">
							<div className="col-sm-7" style={{background: "url(/img/image_3.jpg)"}}>
							</div>
							<div className="col-sm-4 vcenter">
								<div>
									<h3>{this.props.t('Goede prijs - kwaliteit')}</h3>
									<span>{this.props.t('Image-Ik zoek')}</span>
								</div>
							</div>
							<div className="col-sm-1 vcenter">
								<div className="radio-container">
									<input type="radio" name="beforeSizes" checked={this.state.image === '3' ? 'checked' : ''} value='3' onChange={this.handleChange} />
								</div>
							</div>
						</div>
					</div>

					<div className="col-6 text-left">
						<button className="back btn btn-link" onClick={this.goBack}><i className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}</button>
					</div>
					<div className="col-6 text-right">
						<input id="submitbtn" className="btn btn-secondary" type="submit" value={this.props.t('Volgende')} />
					</div>
				</form>

			</div>
		);

	}

	handleChange(event) {
		var value = event.target.value;
		this.setState({image: value});
	}
	handleSubmit(event) {
		event.preventDefault();
		this.props.handler(this.state.image).then( () => {
			if (this.state.image == null) {
				alert(this.props.t('please provide an answer'));
			} else {
				if (this.state.image === '2') {
					this.props.goTo('/advice/brand', this.props.traject);
				} else {
					this.props.goTo('/advice/gender', this.props.traject);
				}
			}
		});
	}
	goBack(event) {
		event.preventDefault();
		if (this.props.traject === 'mtb') {
			if(this.props.usage === '34' || this.props.usage === '33'){
				this.props.goTo('/advice/usage', this.props.traject);
			} else {
				this.props.goTo('/advice/suspension', this.props.traject);
			}
		} else {
			this.props.goTo('/advice/speed', this.props.traject);
		}
	}

}

export default withTranslation('image')(Image);
